<template>
    <div>
        <div class="grid">
            <img class="logo" :src="branding.logo" />
            <div class="social-flex">
                <div v-if="features.showSociaLogos" class="social-media">
                 
                    <div class="icons">
                     
                        <a v-if="branding.facebookUrl" :href="branding.facebookUrl" target="_blank" rel="noopener noreferrer">    <img src="../assets/images/TEMPDEV/facebook-w.png" /></a>

                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

    <script lang="ts">
        import { defineComponent } from "vue";
        import { useTenantConfig } from "../composables/useTenantConfig";

        export default defineComponent({
            name: "Footer",
            setup() {
                const { branding, features } = useTenantConfig();

                return {
                    branding,
                    features,
                };
            },
        });
    </script>





<style scoped >

    .social-media {
        color: white;
        justify-self: end;
    }
    .icons {
        display: flex;
     gap: 0.7rem;
        justify-self: end;
        padding-top:0.7rem;
    }

    .grid {
        display: grid;
        align-items: center;
        justify-content: space-between;
        grid-template-columns: auto auto;
        gap: 1rem;
    }
    .icons img {
        width: 40px;
    }

    .logo {
        width: 100%;
        max-height: 60px;
    }

    @media (max-width: 400px) {
        .grid {
            grid-template-columns: 1fr;
        }

        .social-media {
            justify-self: center;
        }
    }
</style>
